<template>
  <div>
    <selectNetworkAsset ref="selectNetworkAsset" v-on:selectNetworkAssetComplete="selectNetworkAssetComplete"></selectNetworkAsset>
    <Modal :title="title" v-model="modalModel" @on-cancel="modalModelCancel">
      <Form ref="periodicForm" :model="periodicForm" :label-width="100" >
        <FormItem :label="'目标网络设备(' + waitExecAssetLength + ')'">
          <Button type="default" icon="ios-desktop-outline" @click="openSelectNetworkAssetModal" v-if="!waitExecAssetLength" class="w-100 align-left">选择目标网络设备</Button>
          <a v-on:click="openSelectNetworkAssetModal" v-else style="display:block;">继续选择 </a>
          <Tag color="primary" v-for="(value, key, index) in periodicForm.assets" :key="'wait_network_' + index" v-if="value">{{ key }}</Tag>
        </FormItem>
        <FormItem label="定时调度方式" prop="schedule_type">
          <RadioGroup v-model="periodicForm.schedule_type">
            <Radio label="intervals">Interval</Radio>
            <Radio label="crontabs">Crontab</Radio>
          </RadioGroup>
        </FormItem>
        <div v-if="periodicForm.schedule_type === 'intervals'">
          <FormItem label="Every" prop="interval.every">
            <Input v-model="periodicForm.interval.every"/>
          </FormItem>
          <FormItem label="Period" prop="interval.period">
            <Select v-model="periodicForm.interval.period" clearable>
              <Option value="days" key="days">Days</Option>
              <Option value="hours" key="hours">Hours</Option>
              <Option value="minutes" key="minutes">Minutes</Option>
              <Option value="seconds" key="seconds">Seconds</Option>
            </Select>
          </FormItem>
        </div>
        <div v-else>
          <FormItem label="Minute">
            <Input v-model="periodicForm.crontab.minute" :maxlength="60 * 4" />
          </FormItem>
          <FormItem label="Hour">
            <Input v-model="periodicForm.crontab.hour" :maxlength="24 * 4" />
          </FormItem>
          <FormItem label="Day of week">
            <Input v-model="periodicForm.crontab.day_of_week" :maxlength="64" />
          </FormItem>
          <FormItem label="Day of month">
            <Input v-model="periodicForm.crontab.day_of_month" :maxlength="31 * 4"/>
          </FormItem>
          <FormItem label="Month of year">
            <Input v-model="periodicForm.crontab.month_of_year" :maxlength="64" />
          </FormItem>
        </div>
        <FormItem label="启动">
          <i-switch v-model="periodicForm.enabled">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="ok" :loading="submitting">提交</Button>
        <Button @click="modalModel = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ConfigPeriodicExamine, detailConfigStrategy } from '@/api/network'
import selectNetworkAsset from './select-network-asset'

export default {
  name: 'periodic-examine',
  components: {
    selectNetworkAsset
  },
  data () {
    return {
      title: '定时校验',
      modalModel: false,
      periodicForm: {
        id: '',
        assets: {},
        schedule_type: 'intervals',
        interval: {
          every: 1,
          period: ''
        },
        crontab: {
          minute: '*',
          hour: '*',
          day_of_week: '*',
          day_of_month: '*',
          month_of_year: '*'
        },
        enabled: false
      },
      waitExecAssetLength: 0,
      submitting: false
    }
  },
  methods: {
    // 打开Modal
    openModal (id) {
      this.periodicForm.id = id
      detailConfigStrategy(id).then(res => {
        this.periodicForm.schedule_type = res.data.schedule_type
        if (res.data.periodic_task) {
          if (res.data.schedule_type === 'intervals') {
            this.periodicForm.interval = res.data.periodic_task.interval
          } else {
            this.periodicForm.crontab = res.data.periodic_task.crontab
          }
          console.log(res.data.periodic_task.kwargs)
          this.periodicForm.assets = JSON.parse(res.data.periodic_task.kwargs).assets
          this.waitExecAssetLength = Object.keys(this.periodicForm.assets).length
          this.periodicForm.enabled = res.data.periodic_task.enabled
        }
        this.modalModel = true
      }).catch(res => {
        this.$Notice.error({ title: '获取数据失败' })
      })
    },
    // 打开设备选择Modal
    openSelectNetworkAssetModal () {
      this.$refs.selectNetworkAsset.openSelectNetworkAssetModal({}, this.periodicForm.assets)
    },
    // 选择设备完成回调
    selectNetworkAssetComplete (server, length) {
      this.periodicForm.assets = server
      this.waitExecAssetLength = length
    },
    // 提交
    ok () {
      if (this.periodicForm.enabled) {
        if (this.periodicForm.assets === {}) {
          this.$Notice.error({ title: '请选择目标网络设备！' })
          return
        }
        if (this.periodicForm.schedule_type === 'intervals') {
          if (this.periodicForm.interval.every === null) {
            this.$Notice.error({ title: '请填写Every！' })
            return
          } else if (!this.periodicForm.interval.period) {
            this.$Notice.error({ title: '请选择Period！' })
            return
          }
        } else {
          if (!this.periodicForm.crontab.minute) {
            this.$Notice.error({ title: '请填写Minute！' })
            return
          } else if (!this.periodicForm.crontab.hour) {
            this.$Notice.error({ title: '请填写Hour！' })
            return
          } else if (!this.periodicForm.crontab.day_of_week) {
            this.$Notice.error({ title: '请填写Day of week！' })
            return
          } else if (!this.periodicForm.crontab.day_of_month) {
            this.$Notice.error({ title: '请填写Day of month！' })
            return
          } else if (!this.periodicForm.crontab.month_of_year) {
            this.$Notice.error({ title: '请填写Month of year！' })
            return
          }
        }
      }
      this.submitting = true
      ConfigPeriodicExamine(this.periodicForm).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.modalModel = false
        this.submitting = false
        this.$emit('callbackSuccess')
      }).catch(res => {
        this.submitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({ title: '操作失败！' })
        }
      })
    },
    // 关闭模态框触发
    modalModelCancel () {
      this.periodicForm = {
        id: '',
        assets: {},
        schedule_type: 'intervals',
        interval: {
          every: 1,
          period: ''
        },
        crontab: {
          minute: '*',
          hour: '*',
          day_of_week: '*',
          day_of_month: '*',
          month_of_year: '*'
        },
        enabled: false
      }
      this.waitExecAssetLength = 0
    }
  }
}
</script>

<style scoped>

</style>
